import { isEqual } from 'lodash';

/* eslint-disable-next-line */
type PaginationNavigationProps = {
  isDisabled: boolean;
  position: 'left' | 'right';
  text: string;
  onClick: () => void;
};

export function PaginationNavigation(props: PaginationNavigationProps) {
  const { isDisabled, position, text, onClick } = props;

  const buttonBorderStyle = isEqual(position, 'left')
    ? 'rounded-l-md border'
    : 'rounded-r-md border';

  return (
    <button
      className={`relative inline-flex items-center ${buttonBorderStyle} border-gray-300 bg-white text-MuseoSans500 px-2 py-2 text-caption font-medium text-gray-500 hover:bg-gray-50 focus:z-20`}
      disabled={isDisabled}
      onClick={onClick}
    >
      {text}
    </button>
  );
}

export default PaginationNavigation;
